module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      'loader',
      {
        'loader--init': !_vm.appState.init,
        'loader--hidden': _vm.appState.init && !_vm.appState.loading && !_vm.fauxLoading,
        'loader--messages': _vm.messages,
        'loader--dots-active': _vm.dotsActive,
      }
    ]
  }, [_c('div', {
    staticClass: "loader__items"
  }, [_c('div', {
    staticClass: "message__block",
    style: ([_vm.wrapperStyle])
  }), _vm._v(" "), (_vm.messages) ? _c('module-messages', {
    attrs: {
      "messages": _vm.messages
    },
    on: {
      "messages-complete": _vm.onMessagesComplete,
      "messages-height": _vm.onMessagesSetup
    }
  }) : _vm._e(), _vm._v(" "), _c('module-dots')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4542c9aa"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Loader.vue
// module id = 286
// module chunks = 2